import { useQuery } from '@tanstack/react-query';
import { vacationRequestService } from '../../services/vacationRequestService';
import type { VacationApprovalItem } from '../../models/vacationApproval.types';
import { fetchCollaboratorProfiles } from './collaboratorProfiles';

export const VACATION_APPROVALS_QUERY_KEY = 'vacationApprovals';

export function usePendingApprovalsQuery(managerEmail?: string) {
    const queryResult = useQuery({
        queryKey: [VACATION_APPROVALS_QUERY_KEY, managerEmail],
        queryFn: async (): Promise<VacationApprovalItem[]> => {
            if (!managerEmail) return [];

            const requests = await vacationRequestService.getForManager(managerEmail);
            if (requests.length === 0) return [];

            const collaboratorIds = Array.from(new Set(requests.map((r) => r.collaboratorId)));
            const collaboratorsMap = await fetchCollaboratorProfiles(collaboratorIds);

            return requests.map((request) => {
                const collaborator = collaboratorsMap.get(request.collaboratorId);
                return {
                    request,
                    collaboratorRole: collaborator?.positionName ?? null,
                    collaboratorSquad: collaborator?.departmentName ?? null,
                    collaboratorPhotoUrl: collaborator?.photoUrl ?? null,
                    balanceDays: request.balanceDaysSnapshot ?? null,
                    concessiveDeadline: request.concessiveDeadline ?? null,
                };
            });
        },
        enabled: Boolean(managerEmail),
        staleTime: 5 * 60 * 1000,
    });

    return {
        approvals: queryResult.data ?? [],
        isLoading: queryResult.isLoading,
        error: queryResult.error,
    };
}
